import React from "react";
import Head from "next/head";

import CreditCardConsentAgreementMain from "@/components/credit-card-consent-agreement/credit-card-consent-agreement-main";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const CreditCardConsentAgreement = () => {
  return (
    <>
      <Head>
        <title>{seoData.CREDIT_CARD_CONSENT.title}</title>
        <SeoMetaData data={seoData.CREDIT_CARD_CONSENT} />
      </Head>

      <CreditCardConsentAgreementMain />
    </>
  );
};

export default CreditCardConsentAgreement;
